/**
 * Sidebar navigation items for the Dashboard module.
 * Provides navigation to the main application dashboard (home page).
 * Feature-flag gated.
 */
import { Dashboard, DashboardTwoTone } from '@mui/icons-material';

import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';

export interface DashboardNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const DashboardNavItems = (): DashboardNavItemsResult => {
  const navItems: NavItemType = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'collapse',
    icon: Dashboard,
    iconSelected: DashboardTwoTone,
    featureFlag: FEATURE_FLAGS.DASHBOARD_TAB,
    url: '/?module=dashboard',
    showChevron: false
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default DashboardNavItems;
